var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.name,{tag:"component",staticClass:"watermark absolute inset-0 pointer-events-none",style:({ opacity: _vm.opacity })})
}
var staticRenderFns = []

export { render, staticRenderFns }